import React, { createContext, useState } from "react";

// Context oluştur
export const PersonContext = createContext();

export const PersonProvider = ({ children }) => {
  // Başlangıç verisi
  const [persons, setPersons] = useState([
    {
      id: 1,
      firstName: "Ahmet",
      lastName: "Yılmaz",
      expertise: ["Yazılım", "Veri Analizi"],
      location: "İstanbul",
    },
    {
      id: 2,
      firstName: "Ayşe",
      lastName: "Demir",
      expertise: ["Proje Yönetimi"],
      location: "Ankara",
    }, {
      id: 1,
      firstName: "Ahmet",
      lastName: "Yılmaz",
      expertise: ["Yazılım", "Veri Analizi"],
      location: "İstanbul",
    },
    {
      id: 2,
      firstName: "Ayşe",
      lastName: "Demir",
      expertise: ["Proje Yönetimi"],
      location: "Ankara",
    }, {
      id: 1,
      firstName: "Ahmet",
      lastName: "Yılmaz",
      expertise: ["Yazılım", "Veri Analizi"],
      location: "İstanbul",
    },
    {
      id: 2,
      firstName: "Ayşe",
      lastName: "Demir",
      expertise: ["Proje Yönetimi"],
      location: "Ankara",
    }, {
      id: 1,
      firstName: "Ahmet",
      lastName: "Yılmaz",
      expertise: ["Yazılım", "Veri Analizi"],
      location: "İstanbul",
    },
    {
      id: 2,
      firstName: "Ayşe",
      lastName: "Demir",
      expertise: ["Proje Yönetimi"],
      location: "Ankara",
    },
  ]);

  // Yeni kişi ekleme
  const addPerson = (person) => {
    setPersons((prev) => [...prev, { id: prev.length + 1, ...person }]);
  };

  // Kişiyi güncelleme
  const updatePerson = (updatedPerson) => {
    setPersons((prev) =>
      prev.map((p) => (p.id === updatedPerson.id ? { ...updatedPerson } : p))
    );
  };

  // Kişiyi silme
  const deletePerson = (id) => {
    setPersons((prev) => prev.filter((p) => p.id !== id));
  };

  return (
    <PersonContext.Provider
      value={{ persons, addPerson, updatePerson, deletePerson }}
    >
      {children}
    </PersonContext.Provider>
  );
};
